var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { css } from 'styled-components';
export var Breakpoints = {
  UltraWideScreen: 1352,
  WideScreen: 1184,
  Desktop: 960,
  Tablet: 768,
  Mobile: 480
};

var generateMediaQuery = function generateMediaQuery(width) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'max';
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    /* eslint-disable prefer-spread */
    return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    @media (", "-width: ", "em) {\n      ", ";\n    }\n  "])), type, width, css.apply(null, args));
    /* eslint-enable prefer-spread */
  };
};

// iterate through the sizes and create a media template
export var Media = Object.keys(Breakpoints).reduce(function (accumulator, breakpointName) {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  var emSize = Breakpoints[breakpointName] / 16;
  accumulator[breakpointName] = generateMediaQuery(emSize, 'max');
  return accumulator;
}, {});